// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowDiagramStagesInner
 */
export interface WorkflowDiagramStagesInner {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDiagramStagesInner
     */
    entered_at?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDiagramStagesInner
     */
    pending_approvals?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDiagramStagesInner
     */
    stage?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDiagramStagesInner
     */
    status?: WorkflowDiagramStagesInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDiagramStagesInner
     */
    transitioned_by?: string;
}


/**
 * @export
 */
export const WorkflowDiagramStagesInnerStatusEnum = {
    Completed: 'COMPLETED',
    Current: 'CURRENT',
    Pending: 'PENDING'
} as const;
export type WorkflowDiagramStagesInnerStatusEnum = typeof WorkflowDiagramStagesInnerStatusEnum[keyof typeof WorkflowDiagramStagesInnerStatusEnum];


/**
 * Check if a given object implements the WorkflowDiagramStagesInner interface.
 */
export function instanceOfWorkflowDiagramStagesInner(value: object): value is WorkflowDiagramStagesInner {
    return true;
}

export function WorkflowDiagramStagesInnerFromJSON(json: any): WorkflowDiagramStagesInner {
    return WorkflowDiagramStagesInnerFromJSONTyped(json, false);
}

export function WorkflowDiagramStagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDiagramStagesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'entered_at': json['entered_at'] == null ? undefined : json['entered_at'],
        'pending_approvals': json['pending_approvals'] == null ? undefined : json['pending_approvals'],
        'stage': json['stage'] == null ? undefined : json['stage'],
        'status': json['status'] == null ? undefined : json['status'],
        'transitioned_by': json['transitioned_by'] == null ? undefined : json['transitioned_by'],
    };
}

export function WorkflowDiagramStagesInnerToJSON(json: any): WorkflowDiagramStagesInner {
    return WorkflowDiagramStagesInnerToJSONTyped(json, false);
}

export function WorkflowDiagramStagesInnerToJSONTyped(value?: WorkflowDiagramStagesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entered_at': value['entered_at'],
        'pending_approvals': value['pending_approvals'],
        'stage': value['stage'],
        'status': value['status'],
        'transitioned_by': value['transitioned_by'],
    };
}
